import { Skeleton } from '../../../../components/ui/skeleton'

export default function MetricTableSkeleton() {
  return (
    <div className="space-y-3">
      <Skeleton className="h-5 w-36" />
      {Array.from({ length: 3 }).map((_, groupIdx) => (
        <div key={groupIdx} className="border rounded-lg overflow-hidden">
          <div className="flex items-center justify-between p-3 bg-gray-50">
            <Skeleton className="h-4 w-48" />
            <Skeleton className="h-4 w-12" />
          </div>
          <div className="divide-y">
            {Array.from({ length: 4 }).map((_, rowIdx) => (
              <div key={rowIdx} className="flex items-center gap-4 px-3 py-2">
                <Skeleton className="h-3 w-40" />
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-3 w-20" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
